module.exports = __webpack_public_path__ + "img/Farm-Care.91470328.png";